<template>
  <div class="pricing">
    <div class="pricing__title">Розничные наценки</div>

    <BaseBtn
      v-if="configAccess.pricings.main === 2"
      @btnClick="updatePopup(true, 'PopupTotalMarkup')"
      :text="' Установить единую наценку на весь каталог'"
      class="pricing__button" />

    <Table
      v-for="(markup, index) in getMarkups"
      :key="markup.id"
      :markup="markup"
      :typeIndex="index" />
  </div>

</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "AccountMarkup",

  components: {
    Table: () => import('./components/Table'),
    BaseBtn: () => import('@/components/base/BaseBtn')
  },

  metaInfo () {
    return {
      title: `Розничные наценки - Личный кабинет дилера - ${this.userInfo.dealer.name}`,
    }
  },

  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      configAccess: state => state.user.configAccess,
    }),

    ...mapGetters('account', [
      'getMarkups',
    ]),
  },

  methods: {
    ...mapActions('account', [
      'pullMarkups',
    ]),
  },

  created() {
    this.togglePreload();
    this.pullMarkups()
      .finally(() => {
        this.togglePreload();
      })
  }
}
</script>

<style scoped lang="scss">
.pricing {
  @media(max-width: $desktop) {
    padding-bottom: 33px;
  }

  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    position: fixed;
    z-index: 120;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 53px;
    margin: 0;

    @media(max-width: $desktop) {
      position: static;
      height: auto;
      transform: translateX(0);
      margin-bottom: 11px;
    }
  }

  &__button {
    margin-bottom: 16px;

    @media(max-width: $desktop) {
      margin-bottom: 35px;
      padding: 0 10px;
    }
  }
}
</style>
